import React, {useEffect} from 'react';

import 'plugins/fontawesome';

import _, { isArray } from 'lodash';
import moment from 'moment';
import {useQuery} from 'react-query';
import {useHistory} from 'react-router';
import {useLocation} from 'react-router-dom';
import {toast} from 'react-toastify';

import RouteContainer from 'routes/Routes';

import {checkAccount, getTenantInfo, login} from './apis/auth';
import getAuth from './common/getAuth';
import LoadingScreen from './components/common/LoadingScreen';
import ToastMessage from './components/common/toast/ToastMessage';
import {removeCookie, setCookie} from './config/cookies';
import {TENANT_BASE_URL, TENANT_INFO, TOKEN_KEY, USER_NAME} from './constants/Main';
import {AUTH_TENANT_INFO_KEY, AUTH_USER_INFO_KEY, CHECK_DOMAIN_KEY} from './constants/QueryKey';

const App = () => {
  const history = useHistory();
  const location = useLocation();
  const tenant = location.pathname.split('/')[1];
  const {hoscoUsername, tenantInfo} = getAuth();

  const tenantBase = localStorage.getItem(TENANT_BASE_URL);
  const dataTenant = tenantInfo ? JSON.parse(tenantInfo) : null;

  const {data, isLoading} = useQuery(
    CHECK_DOMAIN_KEY, 
    () => checkAccount(tenant),
    {
      suspense: false, 
      enabled: !tenantInfo || isArray(dataTenant?.data),
      initialData: tenantInfo ? JSON.parse(tenantInfo) : {},
      onSuccess: (data) => {
        if(data.meta.status_code === 0){
          const midnight = moment('23:59:59', 'HH:mm:ss').toDate();
          setCookie(TENANT_INFO, JSON.stringify(data), midnight);
        } else {
          removeCookie(TENANT_INFO);
        }
      }
    },
  );

  const {data: tenantData} = useQuery(
    [AUTH_TENANT_INFO_KEY, tenant],
    () => getTenantInfo(tenant),
    {suspense: false, enabled: Boolean(data)}
  );

  React.useEffect(() => {
    if(!_.isEmpty(data)){
      if( data?.status_code === 500 || data?.meta?.status_code === 1) {
        history.push('/error/404');
      } else {
        localStorage.setItem('tenant', data ? data.data.name : '');
        if(data){
          if(!tenantBase){
            localStorage.setItem(TENANT_BASE_URL, data.meta.url_service);
            window.location.reload();
          } else {
            if(tenantBase !== data.meta.url_service){
              localStorage.setItem(TENANT_BASE_URL, data.meta.url_service);
              window.location.reload();
            }
          }
        }
      }
    }
  }, [data]);

  useEffect(() => {
    if(tenantData){
      if(tenantData.meta.status_code !== 0){
        toast.error(
          <ToastMessage msg={ tenantData.meta.message } icon='times-circle' />
        );
        removeCookie(TOKEN_KEY);
        removeCookie(USER_NAME);
      } else {
        setCookie(TOKEN_KEY, tenantData.data.secret_key, 86400);
      }
    }
  },[tenantData]);


  const userQuery = useQuery(
    AUTH_USER_INFO_KEY,
    () => login({username: hoscoUsername}), {suspense: false, enabled: Boolean(hoscoUsername)});


  React.useEffect(() => {
    if(!tenant){
      history.push('/error/404');
    } else {
      if(!hoscoUsername ) {
        history.push(`/${tenant}/login`);
      }
    }
  }, [hoscoUsername]);

  if(userQuery.isLoading || isLoading) {
    return <LoadingScreen />;
  }

  return (
    <>
      <RouteContainer />
    </>
  );
};

export default App;
